export default __webpack_public_path__ + "static/media/living-room.e3e7929c.jpg";